import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query } from '../../request';
import { encodeSortableQuery, SortableQuery } from '@/services/api/request/query';

export interface UpcomingQuery extends PaginatableQuery, SortableQuery {
  timezone: string;
  search: string;
  assignee: number[];
  entityItem: number[];
  availableAtStart?: Date | null;
  availableAtEnd?: Date | null;
  dueAtStart?: Date | null;
  dueAtEnd?: Date | null;
}

export const encodeUpcomingQuery = (query: UpcomingQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  timezone: q.string(query.timezone),
  search: q.string(query.search),
  assignee: q.numericEnums(query.assignee),
  entityItem: q.numericEnums(query.entityItem),
  availableAtStart: q.nullableDate(query.availableAtStart || null),
  availableAtEnd: q.nullableDate(query.availableAtEnd || null),
  dueAtStart: q.nullableDate(query.dueAtStart || null),
  dueAtEnd: q.nullableDate(query.dueAtEnd || null),
});
